import './Products.css';
import { useNavigate } from 'react-router-dom';
import brain2 from './regulator-2.jpg';
import brain3 from './doctor-4.webp';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar.js';
import Footer from './footer.js';
import video_brain from './1.mp4';
import video_brain2 from './2.mp4';
const Products = () => {
  const navigate = useNavigate();
  const { hash } = useLocation();
  const [highlighted, setHighlighted] = useState('');

  const handleNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      setHighlighted(id);
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }
    const clearHighlight = () => {
      setHighlighted('');
    };
    document.addEventListener('click', clearHighlight);
    return () => {
      document.removeEventListener('click', clearHighlight);
    };
  }, [hash]);
  
  return (
    <>
      <Navbar />
      <div className="products-container">
        <div className="products-content">
          <h1>Cnyda Dynamics Product Division</h1>
          <p>
            We are a deep-tech research and innovation company at the intersection of mathematics, science, artificial intelligence, and data intelligence, dedicated to building next-generation cognitive systems that solve complex real-world problems. Our breakthrough cognitive brain architecture enables AI to reason, learn, and interact in a more human-like manner, creating intelligent solutions that combine advanced analytical capabilities with contextual understanding and personalized user experiences.
            Our portfolio includes an AI Doctor that interacts naturally like a human physician while reasoning from medical evidence and clinical knowledge to support informed healthcare decisions. We are also developing advanced AI solutions for insider trading risk quantification to assist stock market regulators, alongside AI Data Analyst and AI Teacher platforms that provide personalized guidance, adaptive learning, and hands-on support, empowering users with trusted intelligence tailored to their unique needs.

          </p>
        </div>

        <div className="card-container_products">
          <div 
            id="regulators" 
            className={`card_products ${highlighted === 'regulators' ? 'highlight-glow' : ''}`}
          >
             <video 
              src={video_brain2} 
              className="card-image_products" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
            <div className="card-content_products">
              <h1 className="card-title_products">Insider Trading Quantifying Risk:</h1>
              <p className="card-text_products">
                We have developed a groundbreaking Cognitive Brain AI architecture specifically designed for regulators worldwide to monitor insider trading risks in the stock markets
              </p>
              <button className="card-btn_products" onClick={(e) => { e.stopPropagation(); handleNavigation('/regulators'); }} >Read More</button>
            </div>
          </div>

          <div 
            id="ai_doctor" 
            className={`card_products ${highlighted === 'ai_doctor' ? 'highlight-glow' : ''}`}
          >
            <video 
              src={video_brain} 
              className="card-image_products" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
            <div className="card-content_products">
              <h1 className="card-title_products">AI Doctor avatar:</h1>
              <p className="card-text_products">
                The company has developed an AI Doctor avatar first of its kind in the World which never hallucinates and works based on evidence.
              </p>
              <button className="card-btn_products" onClick={(e) => { e.stopPropagation(); handleNavigation('/ai_doctor'); }} >Read More</button>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default Products;